/*
 * (c) 2019/12/05 duanzifei modify
 * Email: duanzifei@wps.cn
 * License: KSO
 */
import execService from './../exec';

class Network {
  constructor() {
    this.apiPrefix = 'common.network';

    this.apis = {
      httpRequest: `${this.apiPrefix}.httpRequest`,
      httpRequestQing: `${this.apiPrefix}.httpRequestQing`,
      getDomainUrl: `${this.apiPrefix}.getDomainUrl`
    };
  }

  /**
   * 普通 HTTP 请求
   * @param {Object} options 配置项
   * - url {String}
   * - type {String}
   * - data {Object}
   * - header {Object}
   * - cookie {String}
   * - timeout {Number} 超时时间，单位毫秒
   */
  httpRequest(options) {
    return execService.execPromise(this.apis.httpRequest, options);
  }

  /**
   *
   * @param {Object} options
   * - host {String} 接口的域名(eg. https://driver.wps.cn),
   * - api {String} 接口的路径(eg. /api/v5/links/mine)
   * - params {String} GET接口的参数(eg. offset=0&count=30&orderby=DESC&order=file_mtime)
   * - url {String} 接口的链接(eg. https://driver.wps.cn/api/v5/links/mine?offset=0&count=30&orderby=DESC&order=file_mtime)
   *                如果传了url参数，则不需要host/api/params这三个参数，反过来如果有host/api/params，则不需要url
   * - method {String} 方法，GET/POST/DELETE等
   * - data {Object}
   * - header {Object} 自定义头部，包含需要覆盖的头部键值对
   * - timeout {Number} 超时时间，单位毫秒，默认15秒
   * - auth_type {String} 认证方式，0=WpsSid， 1=App， 2=Account，3=Cookies，默认0
   * - content_type {String} 内容格式，text，application/json，默认text
   */
  httpRequestQing(options) {
    return execService.execPromise(this.apis.httpRequestQing, options);
  }

  /**
   * 获取指定的域名
   * @param {*} service 域名关键字 String | Array, eg. 'account' 或 ['account', 'drive']
   */
  getDomainUrl(service) {
    return execService.execPromise(this.apis.getDomainUrl, { service });
  }
}

export default new Network();
